export default "__VITE_ASSET__B7Cb6OFI__"